import styled from 'styled-components';

const H4 = styled.div`
    font-size: 16px;
    font-weight: ${props => props.fontWeight ? props.fontWeight : "normal"};
    line-height: 24px;
    color: ${props => props.color ? props.color : "#383C42"};
`;

export default H4;